import React from 'react'
import Header from '../Header/Header'

function AdminPage() {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default AdminPage
